import styled from "@emotion/styled";
import { SearchableCard } from "@snapchat/snap-design-system";

export const HostedLensesCard = styled(SearchableCard)`
    min-height: 80vh;

    .sds-vtable-row {
        width: 100%;
    }
`;
